var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor sleep" }, [
    _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
      _c("div", { staticClass: "editor-row-title" }, [_vm._v("Mode")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btnGroup" },
        _vm._l(["duration", "timestamp"], function (mode) {
          return _c(
            "SupsisButton",
            {
              key: mode,
              attrs: {
                classNames:
                  _vm.clone.mode === mode
                    ? "btnGroupItem selected"
                    : "btnGroupItem ",
                primary: _vm.clone.mode === mode,
                ghost: _vm.clone.mode !== mode,
                small: "",
              },
              on: {
                click: function () {
                  return _vm.changeMode(mode)
                },
              },
            },
            [_vm._v("\n                " + _vm._s(mode) + "\n            ")]
          )
        }),
        1
      ),
    ]),
    _vm._v(" "),
    _vm.clone.mode === "duration"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Duration"),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Duration",
                "show-attributes": true,
                "max-character-count": 500,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.duration.value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.duration, "value", $$v)
                },
                expression: "clone.duration.value",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "timestamp"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Pick a Future Date (isodate , timestamp)"),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Timestamp",
                "show-attributes": true,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.timestamp.value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.timestamp, "value", $$v)
                },
                expression: "clone.timestamp.value",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "duration"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize" },
          [
            _c("div", { staticClass: "editor-row-title" }, [_vm._v("Unit:")]),
            _vm._v(" "),
            _c("CustomPicker", {
              attrs: {
                items: _vm.units,
                idKey: "id",
                labelKey: "label",
                title: "Select Duration",
              },
              model: {
                value: _vm.clone.duration.unit,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.duration, "unit", $$v)
                },
                expression: "clone.duration.unit",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }